import { Component } from "react";

export class Footer extends Component{
    render(){
        return (
            <footer className="text-center text-lg-start text-white" style={{backgroundColor: "#1c2331"}} id="foot">
                <section className="d-flex justify-content-between p-4" style={{backgroundColor: "#6351ce"}}>
                <div className="me-5">
                    <span>Get connected with me on social networks:</span>
                </div>
                <div>
                    <a href="mailto: saptarshidey.bdm@google.com" className="text-white me-4">
                    <i className="fab fa-google"></i>
                    </a>
                    <a href="https://www.linkedin.com/in/dey-saptarshi" target="_blank" className="text-white me-4">
                    <i className="fab fa-linkedin"></i>
                    </a>
                    <a href="https://github.com/DarkMortal" target="_blank" className="text-white me-4">
                    <i className="fab fa-github"></i>
                    </a>
                </div>
                </section>
                <section>
                    <div className="row mt-3" style={{paddingLeft: "10px", paddingRight: "10px"}}>
                    <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4" style={{width: "90%",textAlign:"left"}}>
                        <h5 className="text-uppercase fw-bold">About Me</h5>
                        <hr className="mb-9 mt-0 d-inline-block mx-auto" style={{width: "60px", backgroundColor: "#7c4dff", height: "2px"}}/>
                        <p>My name is Saptarshi Dey and I am a skilled Software Engineer adept at crafting elegant solutions to complex problems in the digital realm</p>
                    </div>          
                    </div>
                </section>
                <div className="text-center p-3" style={{backgroundColor: "rgba(0, 0, 0, 0.2)"}}>
                Saptarshi Dey © {new Date().getFullYear()}
                </div>
            </footer>
        );
    }
}